
import { useNavigate } from "react-router-dom";
import { TableBody, TableCell, TableHead, TableRow, Typography, Stack, Pagination } from "@mui/material";
import { separadorMillares } from "../../../hooks/useMillares";
import { MensajeAlertaDanger } from "../../components";
import { LayoutTabla } from "../../layouts";
import { useProductosStore } from "../../../stores";


const paginado = Number(process.env.REACT_APP_PAGINADO);


export const TablaProductos = ({ data, chagePage=() => {}, page=0 }) => {

    
    const navigate = useNavigate();
    const { totalProductos } = useProductosStore();


    const handleDetallesProducto = (uid) => {
        return navigate(`/super/actualizar-prod/${uid}`) 
    }



    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalProductos / +paginado)} disabled={Math.ceil(totalProductos / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'25%'}}>Nombre</TableCell>
                        <TableCell sx={{width:'20%'}}>Categoria</TableCell>
                        <TableCell sx={{width:'13%'}}>Costo Materia</TableCell>
                        <TableCell sx={{width:'13%'}}>Costo Produccion</TableCell>
                        <TableCell sx={{width:'15%'}}>Venta Cliente</TableCell>
                        <TableCell sx={{width:'15%'}}>Venta Distri</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (p) => (
                    <TableRow key={ p.id } onClick={() => handleDetallesProducto(p.id) } sx={{cursor:'pointer'}}>
                        <TableCell>{ p.nombre }</TableCell>
                        <TableCell >
                            {( !p.categoria )
                            ? <Typography variant="span" color='error'>No Dato</Typography>
                            :  p.categoria.nombre 
                            }
                        </TableCell>
                        <TableCell>{(p.costoMateria) ? `$${ separadorMillares(p.costoMateria)}` : 0}</TableCell>
                        <TableCell>{(p.costoProduccion) ? `$${ separadorMillares(p.costoProduccion)}` : 0}</TableCell>
                        <TableCell>{(p.precioVenta) ? `$${ separadorMillares(p.precioVenta)}` : 0}</TableCell>
                        <TableCell>{(p.precioDistri) ? `$${ separadorMillares(p.precioDistri)}` : 0}</TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        :    <MensajeAlertaDanger titulo='No hay productos disponibles' />
        }
        </>
    )
}